var render, staticRenderFns
import script from "./OneProductTechnicalData.vue?vue&type=script&lang=ts&"
export * from "./OneProductTechnicalData.vue?vue&type=script&lang=ts&"
import style0 from "./OneProductTechnicalData.vue?vue&type=style&index=0&id=7d17e201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d17e201",
  null
  
)

export default component.exports